import Lahze from './Lahze';

export default function initializer(time, format, locale){
  return new Lahze(time, format, locale);
}